import React, { Fragment } from 'react'
import { usePutAway } from '../../Context/usePutAway'
import { ExcessNotification } from './ExcessNotification'
import { StepBackNotification } from './StepBackNotification'

interface NotificationPutAwayProps {}

export const NotificationPutAway: React.FC<NotificationPutAwayProps> = () => {
  const { state } = usePutAway()

  return (
    <Fragment>
      {state.isShowNotification && <StepBackNotification />}
      {state.isShowExcess && <ExcessNotification />}
    </Fragment>
  )
}
